import React from 'react';
import { SvgIconProps } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';

export const KeyIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" viewBox="0 0 100 100">
            <defs>
                <path id="a" d="M6 8h85.3v85.3H6z" />
            </defs>
            <clipPath id="b">
                <use xlinkHref="#a" overflow="visible" />
            </clipPath>
            <path fill="#fff" d="M48.7 93.3c23.6 0 42.7-19.1 42.7-42.7S72.2 8 48.7 8 6 27.1 6 50.7s19.1 42.6 42.7 42.6" clipPath="url(#b)" />
            <path
                fill="currentcolor"
                d="M19.5 47.6c-.7 1-.5 2.4.5 3.2l17.3 12.6c.4.3.9.4 1.3.4.7 0 1.4-.3 1.8-.9.7-1 .5-2.4-.5-3.2L22.7 47.1c-1-.8-2.4-.5-3.2.5M45 54.8 20.2 36.2c-1-.8-2.4-.5-3.2.5-.8 1-.5 2.4.5 3.2l24.8 18.5c.4.3.9.5 1.4.5.7 0 1.4-.3 1.8-.9.7-1.1.5-2.5-.5-3.2m5.6-2.1c.8-1 .6-2.4-.4-3.2L33 36.5c-1-.8-2.4-.6-3.2.4-.8 1-.6 2.4.4 3.2l17.2 13c.4.3.9.5 1.4.5.7 0 1.4-.3 1.8-.9M78 39.3c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-2.2 1.8-3.9 3.9-3.9s3.9 1.7 3.9 3.9m5.2 4.5c0-7.5-6.1-13.6-13.6-13.6S56 36.3 56 43.8c0 1.7.3 3.3.9 4.8l-3.1 3.1c-.4.4-.5.8-.5 1.3v3.1H50c-.5 0-1 .2-1.3.5-.4.4-.5.8-.5 1.3V61H45c-.5 0-1 .2-1.3.5-.4.4-.5.8-.5 1.3V66h-3.1c-.5 0-1 .2-1.3.5-.4.4-.5.8-.5 1.3v7.5l2.4.4 20.9-20.9c.2.2.5.3.8.5L41.7 75.9l3.3.5 13.2-13 6.8-6.8-.1-.1c1.4.5 3 .8 4.6.8 7.6.1 13.7-6 13.7-13.5"
                clipPath="url(#b)"
            />
        </svg>
    </SvgIcon>
);
